var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"subtitle is-size-6",attrs:{"href":_vm.field.value},domProps:{"innerHTML":_vm._s(_vm.field.recordValue)}})}
var staticRenderFns = []

export { render, staticRenderFns }